import { Navigate, useLocation } from 'react-router-dom';
import { buildLocalizedPath, readPreferredLanguage } from '../seo';

/**
 * Eski (dil öneksiz) URL'leri `/tr/...` veya `/en/...` yapısına yönlendirir.
 * Örn. `/cozumler` → `/tr/cozumler`
 */
export default function LegacyLocaleRedirect() {
  const location = useLocation();
  const preferred = readPreferredLanguage();
  const target =
    buildLocalizedPath(preferred, location.pathname) + location.search + location.hash;

  return <Navigate to={target} replace />;
}
